<div class="modal-body">
  <div class="card">
    <div class="modal-header modal-close">
      <button type="button" class="close" aria-label="Close" (click)="closeModal()"><span
        aria-hidden="true">&times;</span></button>
    </div>
    <div class="card-header modal-card-header">
      <h4 class="card-title" id="basic-layout-form">{{ 'paymentRequestUrl.title' | translate }}</h4>
      <p class="mb-0">{{ 'paymentRequestUrl.text' | translate }}</p>
    </div>
    <div class="card-body">
      <div class="px-3">
        <form class="form" #paymentRequestUrlForm="ngForm" (ngSubmit)="onSubmit(paymentRequestUrlForm)">
          <div class="form-body">
            <h4 class="form-section">
              <i class="ft-cpu"></i> {{ 'paymentRequestUrl.detailsHeader' | translate }}
            </h4>

            <!-- PaymentRequestId -->
            <div class="form-group d-none d-lg-block">
              <label for="PaymentRequestId">{{ 'paymentRequestUrl.paymentRequestIdFieldLabel' | translate }}</label>
              <input class="form-control" name="PaymentRequestId" #PaymentRequestId="ngModel"
                     [(ngModel)]="currentObject.PaymentRequestId"
                     placeholder="{{'paymentRequestUrl.paymentRequestIdFieldPlaceHolder' | translate}}"
                     readonly="readonly">
            </div>

            <!-- QR Code -->
            <div class="form-group">
              <label>{{ 'paymentRequestUrl.qrCodeFieldLabel' | translate }}</label>
              <qrcode class="qrcode" [qrdata]="currentObject.AuthorizationUrl" [width]="256"
                      [errorCorrectionLevel]="'H'"></qrcode>
            </div>

            <h4 class="form-section">
              <i class="ft-share-2"></i> {{ 'paymentRequestUrl.shareHeader' | translate }}
            </h4>

            <div class="row">
              <div class="col-3">
                <a [href]="emailUrl" class="succes" title="{{'paymentRequestUrl.shareUrlByEmailTitle' | translate}}">
                  <i class="ft-mail font-medium-8"></i>
                </a>
              </div>

              <div class="col-3">
                <a [href]="smsUrl | safeUrl" class="succes"
                   title="{{'paymentRequestUrl.shareUrlBySmsTitle' | translate}}">
                  <i class="ft-message-square font-medium-8"></i>
                </a>
              </div>

              <div class="col-3">
                <a [href]="whatsAppUrl | safeUrl" class="succes"
                   title="{{'paymentRequestUrl.shareUrlByWhatsAppTitle' | translate}}">
                  <i class="fab fa-whatsapp-square fa-2x"></i>
                </a>
              </div>
              <div class="col-3">
                <a (click)="copyUrl(currentObject.AuthorizationUrl)" class="succes"
                   title="{{'paymentRequestUrl.copyUrlToClipboard' | translate}}">
                  <i class="ft-copy font-medium-8"></i>
                </a>
              </div>
            </div>
          </div>
          <div class="clear-float-left"></div>
          <div class="form-actions clear-float-left">
            <!-- Send payment request url by sms -->
            <button [hidden]="!hasSendUrlBySmsPermission || !hasDesktopView" type="button"
                    class="btn btn-primary btn-raised mr-1" (click)="sendUrlBySms()"
                    title="{{'paymentRequestUrl.sendBySmsButtonTitle' | translate}}">
              <i class="ft-message-circle"></i> {{ 'buttons.sendSmsText' | translate }}
            </button>
            <!-- Send payment request url by email -->
            <button [hidden]="!hasSendUrlByEmailPermission || !hasDesktopView" type="button"
                    class="btn btn-primary btn-raised mr-1 " (click)="sendUrlByEmail()"
                    title="{{'paymentRequestUrl.sendByEmailButtonTitle' | translate}}">
              <i class="ft-mail"></i> {{ 'buttons.sendEmailText' | translate }}
            </button>
            <!-- Pay direct -->
            <button [hidden]="hidePayDirect" class="btn btn-raised btn-raised btn-primary mr-1" type="submit"
                    title="{{'paymentRequestUrl.payDirectButtonTitle' | translate}}">
              <i class="ft-check-square"></i> {{ 'buttons.payDirectText' | translate }}
            </button>
            <!-- Close modal -->
            <button type="button" class="btn btn-secondary btn-raised mr-1" (click)="closeModal()">
              <i class="ft-x-square"></i> {{ 'buttons.closeText' | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
